import SearchInput2 from "components/SearchInput2";
import { QrCodeIcon } from "@heroicons/react/24/solid";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useRecoilState, useSetRecoilState } from "recoil";
import { useState } from "react";
import { empProducerCodes, prodCodeModal } from "../atoms/atoms";
import { ProducerCodeSectionProps } from "../types";
import { EmpProducerCodesModal } from "../modals/EmpProducerCodesModal";

const ProducerCodeSection: React.FC<ProducerCodeSectionProps> = ({
  employeeId,
  prodCodeData = [],
}) => {
  const history = useHistory();
  const setEmpProdCodeData = useSetRecoilState(empProducerCodes);
  const [openProdCodeModal, setOpenProdCodeModal] =
    useRecoilState(prodCodeModal);

  const onClickSeeMore = () => {
    setEmpProdCodeData(prodCodeData);
    setOpenProdCodeModal(true);
  };
  const onCloseModal = () => {
    setOpenProdCodeModal(false);
  };

  // Search FIlter
  const [isSearch, setIsSearch] = useState(false);
  const [filteredProdCode, setFilteredProdCode] = useState<any[]>([]);
  const [searchInputField, setSearchInputField] = useState("");

  const handleClearButton = () => {
    setFilteredProdCode([]);
    setIsSearch(false);
    handleSearchProdCode("");
    setSearchInputField("");
  };

  const handleSearchProdCode = (target) => {
    setFilteredProdCode(
      prodCodeData?.filter(
        (x) =>
          (x.carrierName ?? "").toLowerCase().includes(target.toLowerCase()) ||
          (x.producerCode ?? "").toLowerCase().includes(target.toLowerCase())
      )
    );
  };

  const handleHyperlink = (x) => {
    localStorage.setItem("employeeId", employeeId);
    localStorage.setItem("fromModal", "false");

    history.push({
      pathname: "/carrieragreementmgmt/producercodeconfig",
      state: {
        masterCarrierId: x.carrierId,
        carrierProducerCodeId: x.carrierProducerCodeId,
        action: "CarrierProducerCode",
      },
    });

    window.location.reload();
  };

  return (
    <>
      <div className="w-full borderContainer p-2 bg-white px-9">
        {prodCodeData?.length > 5 && (
          <div className="py-2 grid grid-cols-6 gap-1">
            <div className="text-xs col-start-1 col-end-2 flex flex-row">
              <SearchInput2
                className="border-b"
                placeholder="Search "
                id="searchFilter"
                value={searchInputField}
                onChange={(e) => {
                  setSearchInputField(e.target.value);
                  handleSearchProdCode(e.target.value);
                  e.target.value === ""
                    ? setIsSearch(false)
                    : setIsSearch(true);
                }}
                onSelectionChange={() => {}}
              />
              <button
                className="opacity-50 -ml-3 "
                onClick={() => handleClearButton()}
              >
                <label className="-mr-4"> X</label>
              </button>
            </div>
            <button
              onClick={() => onClickSeeMore()}
              className="text-primary text-right underline font-semibold col-end-7 col-span-1"
            >
              See more
            </button>
          </div>
        )}
        <div className="grid gap-2 grid-cols-5">
          {prodCodeData &&
            !isSearch &&
            prodCodeData.map((x, i) => {
              const producerCode = x.producerCode ? x.producerCode : null;
              const mAproducerCode = x.mAproducerCode ? x.mAproducerCode : null;
              const codes = producerCode ?? mAproducerCode ?? "";
              return (
                i <= 4 && (
                  <div
                    key={x.carrierProducerCodeId ?? i}
                    className="bg-white border border-gray-200 w-full shadow-md rounded-md"
                  >
                    <div className="flex p-2">
                      <div className="translate-y-4">
                        <QrCodeIcon className="text-blue-500 h-8 w-8" />
                      </div>
                      <div className="text-gray-600 font-medium ml-2 truncate ">
                        <h3 className="text-xs1 flex items-center font-medium text-gray-400">
                          <svg
                            className={
                              x.isActive
                                ? "text-green-500 mr-1 talic h-2 w-2"
                                : "text-gray-40 mr-1 talic h-2 w-2"
                            }
                            fill="currentColor"
                            viewBox="0 0 8 8"
                          >
                            <circle cx={4} cy={4} r={3} />
                          </svg>{" "}
                          {x.isActive ? "Active" : "Inactive"}
                        </h3>
                        <h1
                          className="tileClasses"
                          onClick={() => {
                            handleHyperlink(x);
                          }}
                        >
                          {codes}
                        </h1>
                        {!x.producerCode && (
                          <h2 className="text-xxs font-medium text-gray-400">
                            {"MA Codes"}
                          </h2>
                        )}

                        <h2 className="text-xs font-medium text-gray-700 mt-1">
                          {x.carrierName ? x.carrierName : "unspecified"}
                        </h2>
                        <h2 className="text-xxs font-medium text-gray-400">
                          {"Employee"}
                        </h2>
                      </div>
                    </div>
                  </div>
                )
              );
            })}
          {isSearch &&
            filteredProdCode?.map((x, i) => {
              const producerCode = x.producerCode ? x.producerCode : null;
              const mAproducerCode = x.mAproducerCode ? x.mAproducerCode : null;
              const codes = producerCode ?? mAproducerCode ?? "";
              return (
                i <= 4 && (
                  <div
                    key={x.carrierProducerCodeId ?? i}
                    className="bg-white border border-gray-200 w-full shadow-md rounded-md"
                  >
                    <div className="flex p-2">
                      <div className="translate-y-4">
                        <QrCodeIcon className="text-blue-500 h-8 w-8" />
                      </div>
                      <div className="text-gray-600  ml-2 truncate ">
                        <h3 className="text-xs1 flex items-center font-normal text-gray-400">
                          <svg
                            className={
                              x.isActive
                                ? "text-green-500 mr-1 talic h-2 w-2"
                                : "text-gray-40 mr-1 talic h-2 w-2"
                            }
                            fill="currentColor"
                            viewBox="0 0 8 8"
                          >
                            <circle cx={4} cy={4} r={3} />
                          </svg>{" "}
                          {x.isActive ? "Active" : "Inactive"}
                        </h3>

                        <h1
                          className="tileClasses"
                          onClick={() => {
                            handleHyperlink(x);
                          }}
                        >
                          {codes}
                        </h1>
                        {!x.producerCode && (
                          <h2 className="text-xxs font-medium text-gray-400">
                            {"MA Codes"}
                          </h2>
                        )}
                        <h2 className="text-xs font-medium text-gray-700 mt-1">
                          {x.carrierName ? x.carrierName : "unspecified"}
                        </h2>
                        <h2 className="text-xxs font-medium text-gray-400">
                          {"Employee"}
                        </h2>
                      </div>
                    </div>
                  </div>
                )
              );
            })}
          {isSearch && filteredProdCode.length === 0 && (
            <div className="flex pt-2 pb-5 items-center justify-center text-sm col-span-5">
              No records to display
            </div>
          )}
        </div>
      </div>
      {openProdCodeModal && (
        <EmpProducerCodesModal
          employeeId={employeeId}
          prodCodeData={prodCodeData}
          showFullView={openProdCodeModal}
          closeFullView={onCloseModal}
        />
      )}
    </>
  );
};

export default ProducerCodeSection;
